import {Box, Typography} from '@mui/material';
import {Hash} from 'lucide-react';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface SextyNineLogoProps {
  variant: `light` | `dark`;
}

export const SextyNineLogo: React.FC<SextyNineLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <Hash
        size={20}
        style={{
          color: isLight ? theme.custom.colors.ui.white : theme.custom.colors.secondary,
          transform: `rotate(45deg)`,
        }}
      />
      <Typography
        sx={{
          fontSize: `20px`,
          fontWeight: 700,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 1px 3px rgba(0, 0, 0, 0.3)`,
              }
            : {
                background: `linear-gradient(135deg, ${theme.custom.colors.secondary} 0%, ${theme.custom.colors.secondaryLight} 50%, ${theme.custom.colors.primary} 100%)`,
                WebkitBackgroundClip: `text`,
                WebkitTextFillColor: `transparent`,
                backgroundClip: `text`,
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: `-0.5px`,
        }}
      >
        69
      </Typography>
    </Box>
  );
};
